function get({ path = '/newsletter', params }) {
  return this.axios.get(path, { params })
}

function itemPostFormData(id, formData) {
  return this.axios.post(`/newsletter/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

function itemPutFormData(id, formData) {
  return this.axios.put(`/newsletter/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

const newsletter = (axios) => ({
  axios,
  get,
  item: {
    axios,
    postFormData: itemPostFormData,
    putFormData: itemPutFormData,
  }
})

export default newsletter
